/**
 * OhMy Stile: Klick auf eine Kachel öffnet ein Overlay über der gesamten Komponente
 * (FLIP-Animation von der Kachel aus, wie bei den USP-Karten) mit interaktivem
 * Vorher/Nachher-Vergleich, Beschreibung und CTA.
 */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 400;

  document.querySelectorAll('[data-ohmy-styles]').forEach(function (grid) {
    var overlay = null;

    function closeOverlay(tile) {
      if (!overlay) return;
      var ov = overlay;
      overlay = null;
      var gridRect = grid.getBoundingClientRect();
      var rect = (tile || ov._sourceTile).getBoundingClientRect();

      ov.classList.remove('is-open');
      grid.style.minHeight = '';
      if (reducedMotion) { ov.remove(); return; }
      ov.style.top = (rect.top - gridRect.top) + 'px';
      ov.style.left = (rect.left - gridRect.left) + 'px';
      ov.style.width = rect.width + 'px';
      ov.style.height = rect.height + 'px';
      setTimeout(function () { ov.remove(); }, DURATION);
    }

    function openOverlay(tile) {
      if (overlay) { closeOverlay(); return; }

      var gridRect = grid.getBoundingClientRect();
      var rect = tile.getBoundingClientRect();
      var d = tile.dataset;
      var labels = grid.dataset;

      var ov = document.createElement('div');
      ov.className = 'ohmy-styles__overlay';
      ov._sourceTile = tile;

      var ba = '';
      if (d.before && d.after) {
        ba =
          '<div class="ohmy-ba">' +
            '<img src="' + d.after + '" alt="">' +
            '<div class="ohmy-ba__before"><img src="' + d.before + '" alt=""></div>' +
            '<div class="ohmy-ba__handle"></div>' +
            (labels.labelBefore ? '<span class="ohmy-ba__badge ohmy-ba__badge--before">' + labels.labelBefore + '</span>' : '') +
            (labels.labelAfter ? '<span class="ohmy-ba__badge ohmy-ba__badge--after">' + labels.labelAfter + '</span>' : '') +
            '<input class="ohmy-ba__range" type="range" min="0" max="100" value="50" aria-label="' + (labels.labelBefore || '') + ' / ' + (labels.labelAfter || '') + '">' +
          '</div>';
      } else if (d.after) {
        ba = '<div class="ohmy-ba"><img src="' + d.after + '" alt=""></div>';
      }

      ov.innerHTML =
        '<button type="button" class="ohmy-styles__overlay-close" data-style-close>' +
          '<svg viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="ohmy-styles__overlay-body">' +
          ba +
          '<div class="ohmy-styles__overlay-info">' +
            (d.title ? '<h3 class="h4">' + d.title + '</h3>' : '') +
            (d.description ? '<p>' + d.description + '</p>' : '') +
            (d.url && labels.labelCta ? '<a href="' + d.url + '" class="button button--primary justify-self-start">' + labels.labelCta + '</a>' : '') +
          '</div>' +
        '</div>';

      if (labels.imageFit === 'contain') ov.classList.add('ohmy-styles__overlay--contain');
      if (labels.showDescMobile === 'false') ov.classList.add('ohmy-styles__overlay--hide-desc-mobile');

      grid.appendChild(ov);
      overlay = ov;

      ov.style.top = (rect.top - gridRect.top) + 'px';
      ov.style.left = (rect.left - gridRect.left) + 'px';
      ov.style.width = rect.width + 'px';
      ov.style.height = rect.height + 'px';

      var targetH = Math.max(gridRect.height, 420);
      var run = function () {
        ov.classList.add('is-open');
        ov.style.top = '0px';
        ov.style.left = '0px';
        ov.style.width = gridRect.width + 'px';
        ov.style.height = targetH + 'px';
        grid.style.minHeight = targetH + 'px';
        // Nach der Animation: Höhe an tatsächlichen Inhalt anpassen (z. B. Beschreibung auf Mobil)
        setTimeout(function () {
          if (overlay !== ov) return;
          var body = ov.querySelector('.ohmy-styles__overlay-body');
          if (body && body.scrollHeight > ov.clientHeight) {
            var needed = body.scrollHeight;
            ov.style.height = needed + 'px';
            grid.style.minHeight = needed + 'px';
          }
        }, DURATION + 20);
      };

      if (reducedMotion) {
        run();
      } else {
        ov.getBoundingClientRect();
        ov.classList.add('is-animating');
        requestAnimationFrame(run);
      }

      // Vorher/Nachher-Regler
      var range = ov.querySelector('.ohmy-ba__range');
      if (range) {
        var baEl = ov.querySelector('.ohmy-ba');
        range.addEventListener('input', function () {
          baEl.style.setProperty('--pos', range.value + '%');
        });
      }
    }

    grid.addEventListener('click', function (e) {
      if (e.target.closest('[data-style-close]')) {
        closeOverlay();
        return;
      }
      if (e.target.closest('.ohmy-styles__overlay')) return; // Interaktion im Overlay
      var tile = e.target.closest('[data-style-tile]');
      if (tile) openOverlay(tile);
    });

    window.addEventListener('resize', function () { if (overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay) closeOverlay(); });
  });
})();
